import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { BookOpen, Target, Users, CheckCircle } from 'lucide-react'

const HRConsulting = () => {
  const services = [
    'Policy development and review',
    'Compliance guidance',
    'Performance management systems',
    'Strategic HR planning'
  ]

  return (
    <div>
      <section className="bg-gradient-to-br from-primary-800 via-primary-700 to-teal-700 text-white py-16 md:py-20">
        <div className="container-max">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">HR Consulting Services</h1>
            <p className="text-lg md:text-xl text-primary-100">Strategic HR guidance to optimize your workforce</p>
            <div className="w-20 h-1 bg-accent-500 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary-800 mb-6">Strategic HR Solutions</h2>
              <p className="text-secondary-500 mb-6">Our HR consultants help you build stronger organizations through strategic human resources planning, policy development, and compliance management.</p>
              <ul className="space-y-3">
                {services.map((service, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-600">{service}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="HR Consulting" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default HRConsulting
